import React from "react";
import { TagCloud } from 'react-tagcloud'

const Cloud = () => {
    const Tags = [
        {
            value: "Web Security",
            count: 30
        },
        {
            value: "Network Security",
            count: 25
        },
        {
            value: "Cloud",
            count: 15
        },
        {
            value: "Linux",
            count: 20
        },
        {
            value: "Python",
            count: 35
        },
        {
            value: "GoLang",
            count: 25
        },
        {
            value: "Java",
            count: 25
        },
        {
            value: "JavaScript",
            count: 28
        },
        {
            value: "ReactJS",
            count: 30
        },
        {
            value: "MongoDB",
            count: 15
        },
        {
            value: "SQL",
            count: 14
        },
        {
            value: "PowerShell",
            count: 14
        },
        {
            value: "Flask",
            count: 22
        },
        {
            value: "Burp Suite",
            count: 28
        },
        {
            value: "Metasploit",
            count: 30
        },
        {
            value: "NMap",
            count: 32
        },
        {
            value: "GCP",
            count: 18
        },
        {
            value: "AWS",
            count: 20
        },
        {
            value: "GitHub",
            count: 22
        },
        {
            value: "Docker",
            count: 14
        }]

    return (
        <TagCloud tags={Tags} maxSize={35} minSize={12} shuffle={true} randomSeed={true}/>
    )
};

export default Cloud